<script>
    import windows from "../../stores/windows.js";
    import journal from "../../stores/journal.js";
    import Scroll from "../windows/Scroll.svelte";

    export let store;
    export let unit;
    export let sourceTitle;
    export let window;

    let image;

    $: currentArticle = $store.all[$store.indexForCurrent];

    $: currentArticle &&
        journal.remember(
            `read ${unit} about ${currentArticle.title} saying that ${currentArticle.text || currentArticle.body}`
        );

    $: isHovered = $windows.find(({ id }) => id === window.id)?.isHovered === true;

    $: (() => {
        if (currentArticle && currentArticle.image && currentArticle.image !== image) {
            const e = new Image();
            e.src = currentArticle.image;
            e.onload = () => {
                image = currentArticle.image;
            };
        }

        if (!currentArticle || currentArticle.image !== image) {
            image = null;
        }
    })();

    $: (() => {
        if (isHovered) {
            store.pause();
        } else {
            store.resume();
        }
    })();

    function didClickImage(e) {
        const id = windows.open("photo", {
            photos: [
                {
                    url: e.target.src,
                    title: currentArticle.title
                }
            ],
            z: window.z
        });

        windows.focus(id);
    }
</script>

{#if currentArticle}
    <Scroll isFocused={window.isFocused}>
        <h3>{currentArticle.title}</h3>
        <p>
            <img on:click={didClickImage} src={image} alt={currentArticle.title} hidden={!image} />
            {currentArticle.text || currentArticle.body}
        </p>
        <p><span>From {sourceTitle}</span></p>
    </Scroll>
{:else if $store.isLoading}
    <div>
        <p>Loading {unit}...</p>
    </div>
{:else}
    <div>
        <p>Nothing found.</p>
    </div>
{/if}

<style>
    div {
        padding: var(--chrome-depth);
    }

    span {
        color: gray;
    }

    img {
        float: right;
        cursor: pointer;
        padding-bottom: var(--spacing);
        padding-left: var(--spacing);
        width: 33%;
    }
</style>
